import React from 'react';
import './TipsShowReview.css';

const formatCreators = (creators) => {
  if (!creators) return '';
  if (Array.isArray(creators)) return creators.join(', ');
  return creators; // if it's already a string, return as is
};

export const TipsShowReview = ({ 
  actors, 
  creators,
  releaseDate,
  review,
  reviewer,
  reviewDate 
}) => {
  const creatorsList = formatCreators(creators);
  const actorsList = formatCreators(actors);

  return (
    <div className="tips-show-review">
      {(actors?.length > 0 || creators?.length > 0 || releaseDate) && (
        <div className="tips-show-date">
          {releaseDate && (
            <div className="tips-release">
              <span className="tips-label">Premiär:</span>
              <span className="tips-names">{releaseDate}</span>
            </div>
          )}
          {creators?.length > 0 && (
            <div className="tips-creators">
              <span className="tips-label">Skapare:</span>
              <span className="tips-names">{creatorsList}</span>
            </div>
          )}
          {actors?.length > 0 && (
            <div className="tips-actors">
              <span className="tips-label">Skådespelare:</span>
              <span className="tips-names">{actorsList}</span>
            </div>
          )}
        </div>
      )}
      
      {review && (
        <div className="tips-review-content">
          <p className="tips-review-text">{review}</p>
          <div className="tips-review-meta">
            {reviewer && <span className="tips-reviewer">{reviewer}</span>}
            {reviewDate && (
              <span className="tips-review-date">
                {new Date(reviewDate).toLocaleDateString('sv-SE')}
              </span>
            )}
          </div>
        </div>
      )}
    </div>
  );
}; 